export default __webpack_public_path__ + "static/media/helpful-doctors.e93d04e4.jpg";